'use strict';

let $ = window.jQuery || window.$;

export default $;
